module.exports = __webpack_public_path__ + "img/ussd-light.5b7e3117.svg";